<template>
  <div class="data-box component">

    <div class="data-box-content" :class="{'loading': loading}" v-if="loading">
      <SpinnerWave></SpinnerWave>
    </div>

    <div class="data-box-content" :class="{'loading': loading}" v-show="!isEmpty && !error && !loading">
      <slot></slot>
    </div>

    <div class="data-box-content is-empty" v-if="isEmpty && !error && !loading">
      <div class="smile">(>_<)</div>
      <div class="title">No content!</div>
    </div>

    <div class="data-box-content error" v-if="error">
      <div class="smile">(>_<)</div>
      <div class="title">Something wrong here!</div>
      <div class="error-msg">{{ error }}</div>
    </div>
  </div>
</template>
<script type="text/babel">
  import SpinnerWave from './SpinnerWave.vue'

  export default {
    name: 'DataBox',
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      isEmpty: {
        type: Boolean,
        default: false
      },
      error: {
        type: [String, Boolean],
        default: false
      }
    },
    components: { SpinnerWave }
  }
</script>

<style scoped lang="scss">
  .data-box.component {
    position: relative;
    width: 100%;
    height: 100%;
    .data-box-content {
      height: 100%;
    }
    .data-box-content.loading {
      display: flex;
      align-items: center;
      min-height: 200px;
      opacity: .3;
      pointer-events: none;
    }
    .is-empty, .error{
      text-align: center;
      padding: 30px;
      font-size: 16px;
      .title {
        font-size: 20px;
      }
      .smile {
        font-size: 120px;
        padding-bottom: 20px;
      }
    }

    .error {
      color: $color-error;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .error-msg {
        padding-top: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DataBox.vue